// Library methods

// Utils
import { POST } from '../../../utils/fetchWrappers';

// API URLs
import {
    API_FETCH_MIXED_GRAPH,
    API_FETCH_MULTI_GRAPH,
    API_FETCH_SINGLE_GRAPH,
    API_FETCH_SUMMARY_GRAPH,
    API_HIERARCHY_LIST_MULTI,
} from '../../../utils/API/apiUrls';

// Toast Messages
import { ERROR_MESSAGES } from '../../../utils/constants/toastMessages';

// API Status Codes
import { apiStatusCodes } from '../../../utils/API/apiStatusCodes';

// Redux Actions
import * as loaderActions from '../../../redux/common/loader/loader.actions';
import * as dashboardActions from './dashboard.actions';

// Constants
import {
    FETCH_MIXED_GRAPH_REQUEST,
    FETCH_MULTI_GRAPH_REQUEST,
    FETCH_SINGLE_REQUEST,
    FETCH_DASHBOARD_SUMMARY_REQUEST,
    FETCH_MULTI_ENTITY_HIERARCHY_REQUEST,
} from './dashboard.constants';
import { takeLatest, takeEvery, put, call } from 'redux-saga/effects';

export function* fetchMixedGraph(actions) {
    // yield put(loaderActions.showLoader());
    try {
        const { payload } = actions;
        const request = {
            dashboardFilter: {
                createdEndDate: payload.endDate,
                createdStartDate: payload.startDate,
                merchantIds: payload.merchantIds,
                // merchantIds: ['MERMERf62f649', 'MERMER69c617e'],
            },
            graphIdentifier: 'OVER_ALL_FAILURES',
        };
        const { data } = yield call(POST, API_FETCH_MIXED_GRAPH, request);
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(dashboardActions.fetchMixedGraphSuccess(data.values));
        } else if (data && data.errorMessage) {
            yield put(
                dashboardActions.fetchMixedGraphError({
                    errorMsg: data.errorMessage,
                })
            );
        }
    } catch ({ response }) {
        const { data } = response;
        const errorMsg = (data && data.errorMessage) || ERROR_MESSAGES.LOGOUT;
        yield put(dashboardActions.fetchMixedGraphError({ errorMsg }));
    }
    // yield put(loaderActions.hideLoader());
}

export function* fetchMultiGraph(actions) {
    // yield put(loaderActions.showLoader());
    try {
        const { payload } = actions;
        const request = {
            dashboardFilter: {
                createdEndDate: payload.endDate,
                createdStartDate: payload.startDate,
                merchantIds: payload.merchantIds,
            },
            graphIdentifier: 'PAYMENT_MODE_WISE_SUCCESS_RATE',
        };
        const { data } = yield call(POST, API_FETCH_MULTI_GRAPH, request);
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(dashboardActions.fetchMultiGraphSuccess(data.values));
        } else if (data && data.errorMessage) {
            yield put(
                dashboardActions.fetchMultiGraphError({
                    errorMsg: data.errorMessage,
                })
            );
        }
    } catch ({ response }) {
        const { data } = response;
        const errorMsg = (data && data.errorMessage) || ERROR_MESSAGES.LOGOUT;
        yield put(dashboardActions.fetchMultiGraphError({ errorMsg }));
    }
    // yield put(loaderActions.hideLoader());
}

export function* fetchSingleGraph(actions) {
    // yield put(loaderActions.showLoader());
    try {
        const { payload } = actions;
        const request = {
            dashboardFilter: {
                createdEndDate: payload.endDate,
                createdStartDate: payload.startDate,
                merchantIds: payload.merchantIds,
            },
            graphIdentifierList: [payload.graphIdentifier],
            // graphIdentifierList: [
            //     'GMV',
            //     'STATUS_TREND',
            //     'SUCCESS_RATE',
            //     'TRANSACTIONS_COUNT',
            // ],
        };
        const { data } = yield call(POST, API_FETCH_SINGLE_GRAPH, request);
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(
                dashboardActions.fetchSingleGraphSuccess({
                    data,
                    graphIdentifier: payload.graphIdentifier,
                })
            );
        } else if (data && data.errorMessage) {
            yield put(
                dashboardActions.fetchSingleGraphError({
                    errorMsg: data.errorMessage,
                })
            );
        }
    } catch ({ response }) {
        const { data } = response;
        const errorMsg = (data && data.errorMessage) || ERROR_MESSAGES.LOGOUT;
        yield put(dashboardActions.fetchSingleGraphError({ errorMsg }));
    }
    // yield put(loaderActions.hideLoader());
}

export function* fetchDashboardSummary(actions) {
    // yield put(loaderActions.showLoader());
    try {
        const { payload } = actions;
        const request = {
            dashboardFilter: {
                createdEndDate: payload.endDate,
                createdStartDate: payload.startDate,
                merchantIds: payload.merchantIds,
            },
        };
        const { data } = yield call(POST, API_FETCH_SUMMARY_GRAPH, request);
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(
                dashboardActions.fetchDashboardSummarySuccess(
                    data.summaryMetrics
                )
            );
        } else if (data && data.errorMessage) {
            yield put(
                dashboardActions.fetchDashboardSummaryError({
                    errorMsg: data.errorMessage,
                })
            );
        }
    } catch ({ response }) {
        const { data } = response;
        const errorMsg = (data && data.errorMessage) || ERROR_MESSAGES.LOGOUT;
        yield put(dashboardActions.fetchDashboardSummaryError({ errorMsg }));
    }
    // yield put(loaderActions.hideLoader());
}

export function* fetchHierarchyDetails(actions) {
    // yield put(merchantAction.showHierarchyLoader());
    try {
        const { payload, level, entityType, onSuccess } = actions;
        const request = {
            entityCode: payload,
            entityLevel: level,
        };
        const { data } = yield call(POST, API_HIERARCHY_LIST_MULTI, request);
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(
                dashboardActions.fetchMultiEntityHierarchySuccess(
                    data,
                    entityType
                )
            );
            if (onSuccess) {
                onSuccess();
            }
        } else if (data && data.errorMessage) {
            yield put(
                dashboardActions.fetchMultiEntityHierarchyError({
                    error: data,
                })
            );
        }
    } catch ({ response }) {
        const data = response && response.data;
        yield put(
            dashboardActions.fetchMultiEntityHierarchyError({ error: data })
        );
    }
    // yield put(merchantAction.hideHierarchyLoader());
}

/**
 * WATCHER SAGA
 */
export function* dashBoardSaga() {
    yield takeLatest(FETCH_MIXED_GRAPH_REQUEST, fetchMixedGraph);
    yield takeLatest(FETCH_MULTI_GRAPH_REQUEST, fetchMultiGraph);
    yield takeEvery(FETCH_SINGLE_REQUEST, fetchSingleGraph);
    yield takeLatest(FETCH_DASHBOARD_SUMMARY_REQUEST, fetchDashboardSummary);
    yield takeEvery(
        FETCH_MULTI_ENTITY_HIERARCHY_REQUEST,
        fetchHierarchyDetails
    );
}
